import { Color, LayerRect } from '@/types/models';
import { LayerObjectAdapter } from '@/utils/layer/LayerObjectAdapter';

export function getLayerRectAdapterId(id: number): string {
  return `rect-${id}`;
}

export class LayerRectAdapter implements LayerRect, LayerObjectAdapter {
  public id: number;

  public x: number;

  public y: number;

  public z: number;

  public width: number;

  public height: number;

  public layer: number;

  public borderColor: Color;

  public fillColor: Color;

  public borderThickness: number;

  constructor(layerRect: LayerRect) {
    this.id = layerRect.id;
    this.x = layerRect.x;
    this.y = layerRect.y;
    this.z = layerRect.z;
    this.width = layerRect.width;
    this.height = layerRect.height;
    this.layer = layerRect.layer;
    this.borderColor = layerRect.borderColor;
    this.fillColor = layerRect.fillColor;
    this.borderThickness = layerRect.borderThickness;
  }

  public getId(): string {
    return getLayerRectAdapterId(this.id);
  }

  public getOriginalId(): number {
    return this.id;
  }
}
